import { ThemeEvents } from '@theme/events';

/**
 * Products can be forced sold-out via a metafield (availability_status), independent of
 * Shopify's per-variant inventory. `blocks/buy-buttons.liquid` renders this correctly on
 * first load, but the built-in variant-change handling in `product-form.js` re-enables the
 * add-to-cart / accelerated-checkout buttons based only on the selected variant's own
 * `available` flag, which knows nothing about the metafield override.
 *
 * `product-form-component[data-force-sold-out="true"]` is a static, product-level flag set
 * once from Liquid and never touched by the variant-morph logic, so it stays reliable across
 * variant switches. Listening on `document` means this runs after the section-level listener
 * product-form.js attaches (closer to the event target in the bubble path), so it can
 * re-apply the forced sold-out state each time a variant changes.
 */
document.addEventListener(ThemeEvents.variantUpdate, (event) => {
  const { target } = event;
  if (!(target instanceof Element)) return;

  const container = target.closest('.shopify-section, dialog, product-card');
  if (!container) return;

  const forcedProductForms = container.querySelectorAll('product-form-component[data-force-sold-out="true"]');

  forcedProductForms.forEach((productForm) => {
    const addToCartButton = productForm.querySelector('[ref="addToCartButton"]');
    if (addToCartButton instanceof HTMLButtonElement) {
      addToCartButton.disabled = true;
    }

    const acceleratedCheckout = productForm.querySelector('[ref="acceleratedCheckoutButtonContainer"]');
    acceleratedCheckout?.setAttribute('hidden', 'true');
  });
});
